<template>
    <div class="row p-5 text-center font-gray-dark">
        <div class="col-lg-12">
            <h3 class="fas fa-envelope"></h3>
            <div>
                Por el momento no tienes mensajes
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/messages/ConversationsEmpty.vue